module.exports = __webpack_public_path__ + "img/paragraph-center-align.7d3ade05.svg";